import { Injectable } from '@angular/core';
import { BaseRequestOptions, RequestOptions } from '@angular/http';

@Injectable()
export class DefaultRequestOptions extends BaseRequestOptions {
//xoxo headers for netlify

  constructor() {
    super();

    let username : string = 'dannylane';
    let password : string = 'dannylane2017';

    // Set the default 'Authorization' header
    this.headers.set('Authorization', 'Basic ' + btoa(username + ":" + password));
  }

}

export const requestOptionsProvider = { provide: RequestOptions, useClass: DefaultRequestOptions };


// WEBPACK FOOTER //
// ./src/app/default-request-options.service.ts